import moment from "moment";

export const formatHookFormValuesToSaveMedicalForm = (
  json: any[],
  formValues: any,
) => {
  const formResponses = [...json];
  for (const field in formValues) {
    const fieldValue = formValues[field];
    let [type, index, ...restOfKeys] = field.split("_");
    formResponses[parseInt(index)].response = {
      ...(formResponses[parseInt(index)].response || {}),
      [`${restOfKeys.join("_")}` || "input_value"]: fieldValue || "",
    };
  }

  return formResponses.map((row) =>
    row.response ? row : { ...row, response: {} },
  );
};

export const formatMedicalFormJsonToDefaultValues = (json: any[] = []) => {
  const defaultValues: any = {};
  for (const item of json) {
    const { fieldName, type } = item;
    for (const responseKey in item.response) {
      const key =
        responseKey === "input_value"
          ? fieldName
          : `${fieldName}_${responseKey}`;
      let response = item.response[responseKey];
      if (key.includes("calendar") && response && moment(response).isValid())
        response = new Date(response);
      defaultValues[key] = response;
    }
  }
  return defaultValues;
};
